import { Link } from "react-router-dom";
import { BOM } from "../../../../services/definedMethod";

/*!*******************************************************************************!
  !*** MANAGE TAX COMPONENTS API CONFIG                                                       ***!
  \*******************************************************************************/
export const manageTaxComponentsAPI = {
    ManageTaxComponents: BOM.baseUrl("taxes/component"),
    getTaxComponentTemplate: BOM.baseUrl("taxes/component/template"),
    createTaxComponent: BOM.baseUrl("taxes/component"),

};

/*!*******************************************************************************!
  !*** MANAGE TAX COMPONENTS LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const manageTaxComponentsLabel = {
    manageTaxComponents: "Manage Tax Components",
    newTaxComponentMsg: "Tax Component was successfully created",
    newTaxComponent: "New Tax Component",
    name: "Name",
    percentage: "Percentage",
    creditAccountType: "Credit Account Type",
    creditAccount: "Credit Account",
    startDate: "Start date",
    detailTaxComponent: "Tax Component Detail",
    generalInfo: "General Information",
    editTaxComponent: "Edit Tax Component",
    editTaxComponentMsg: "Tax Component was successfully edited",
    taxComponents: "Tax Components",
    viewTaxComponents: "Tax Components Details",

};

/*!*******************************************************************************!
    !*** MANAGE TAX COMPONENTS STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const manageTaxComponentsStatic = {
    manageTaxComponentSetupItems: [{ title: manageTaxComponentsLabel.manageTaxComponents }],
    detailFxRateItems: [
        { title: <Link to="/prd1300">{manageTaxComponentsLabel.manageTaxComponents}</Link> },
        { title: manageTaxComponentsLabel.detailTaxComponent},
    ],
    newTaxComponentItems: [
        { title: <Link to="/prd1300">{manageTaxComponentsLabel.manageTaxComponents}</Link> },
        { title: manageTaxComponentsLabel.newTaxComponent },
    ],
    editTaxComponentItems: [
        { title: <Link to="/prd1300">{manageTaxComponentsLabel.manageTaxComponents}</Link> },
        { title: manageTaxComponentsLabel.editTaxComponent },
    ],
    taxComponentSetupItems: [{ title: manageTaxComponentsLabel.taxComponents }],
    viewTaxComponentBreadCrumbItems: [
        { title: <Link to="/view-tax-setup">{manageTaxComponentsLabel.taxComponents}</Link> },
        { title: manageTaxComponentsLabel.viewTaxComponents},
    ],
};

